<template>
  <div class="details">
    <van-sticky>
      <div
        class="detailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">{{
          data.type == 1 ? "装饰个人代理人" : "装饰企业代理人"
        }}</span>
        <img
          class="navRight"
          @click="more()"
          src="./../../../assets/decoration/more.png"
        />
      </div>
    </van-sticky>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      style="min-height: 100vh"
    >
      <div class="content">
        <detailsTopTip
          v-if="data.id"
          :data="data"
          :countDown="countDown"
        ></detailsTopTip>
        <!-- 代理人信息 -->
        <div
          class="user"
          :style="{
            backgroundImage:
              data.type == 1
                ? 'url(' + personageIcon + ')'
                : 'url(' + enterpriseIcon + ')',
          }"
        >
          <div>
            <h3>Hi~编号{{ data.id }}</h3>
            <p>
              <!-- 成立过代理人才有 -->
              代理有效期至：<span>{{
                data.is_agent == 1 ? data.ended_at : "-"
              }}</span>
              <img
                v-if="isExpire"
                src="./../../../assets/decoration/expire.png"
              />
            </p>
          </div>
          <!-- <img src="./../../../assets/decoration/agent.png" alt="" /> -->
        </div>
        <div class="detailsData" v-if="data.is_agent == 1">
          <!-- 提现信息 -->
          <div class="withdraw">
            <p>当前可提现：</p>
            <div class="mid">
              <h1>{{ balanceData.balance }}</h1>
              <img
                @click="toEmbody()"
                src="./../../../assets/decoration/right3.png"
                alt=""
              />
              <!-- <span class="noForbidden">去提现</span> -->
            </div>
            <div class="btmDet">
              <div class="item">
                <p>结算总计</p>
                <span>{{ balanceData.settled }}</span>
              </div>
              <div class="line"></div>
              <div class="item">
                <p>已提现</p>
                <span>{{ balanceData.withdrawn }}</span>
              </div>
              <div class="line"></div>
              <div class="item">
                <p>订单数</p>
                <span>{{ balanceData.order_count }}</span>
              </div>
            </div>
          </div>
          <!-- 分佣信息 -->
          <div class="fy">
            <CentCommission
              ref="centCommission"
              :is_agent="true"
              :city_agent_id="data.id"
              :minDate="new Date(data.created_at)"
              :isiOSX="isiOSX"
            ></CentCommission>
          </div>
        </div>
        <!-- 初次成为代理人提示信息 -->
        <DetailsbomTip
          v-else
          :data="data"
          :countDown="countDown"
        ></DetailsbomTip>
      </div>
    </van-pull-refresh>

    <van-dialog
      v-model="data.is_system_error"
      show-cancel-button
      confirm-button-text="重新申请"
      cancel-button-text="关闭"
      theme="round-button"
      width="280px"
      confirmButtonColor="#5853E9"
      cancelButtonColor="rgba(88, 83, 233, .1)"
      @confirm="afreshSign()"
    >
      <div class="dialogStyle">
        合同拉取异常，请联系后台人员 （0571-87178005）处理后重新申请
      </div>
    </van-dialog>
  </div>
</template>
<script>
import DetailsTopTip from "../components/detailsTopTip.vue";
import DetailsbomTip from "../components/detailsbomTip.vue";
import CentCommission from "./../components/centCommission.vue";
export default {
  data() {
    return {
      isiOSX: false,
      data: {},
      countDown: 0,
      isExpire: false,
      balanceData: {},
      equipment: 10, //10安卓，11ios
      isLoading: false,
      dateDown: null,
      identityType: 1, //1个人，2企业
      personageIcon: require("./../../../assets/decoration/agent.png"),
      enterpriseIcon: require("./../../../assets/decoration/agentQy.png"),
    };
  },

  components: { CentCommission, DetailsTopTip, DetailsbomTip },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
  },
  mounted() {
    // 获取当前身份
    this.getIdentityType();
    this.deductionUA();
  },
  methods: {
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    goBack() {
      if (this.equipment == 10) {
        this.params("", "1", "decorateBackOn");
      }
      this.$router.push({
        path: "/decoration/index",
        query: {
          token: JSON.parse(sessionStorage.getItem("token")),
        },
      });
    },
    // 下拉刷新
    onRefresh() {
      this.getData();
      this.getBalanceData();
      if (this.$refs.centCommission) {
        this.$refs.centCommission.onRefresh();
      }
    },
    // 获取代理人当前身份
    getIdentityType() {
      this.$api.get("decoration/member/city/agent/switch/role").then((res) => {
        this.identityType = res.type;
        this.getData();
        this.getBalanceData();
      });
    },
    getData() {
      this.$api
        .get("decoration/member/city/agent/show", {
          type: this.identityType,
        })
        .then((res) => {
          this.isLoading = false;
          this.data = res;
          this.data.created_at = this.data.created_at.replace(/-/g, "/");
          this.countDown = res.overdue_at;
          if (this.data.is_renewal_no_pay_order || this.data.is_no_pay_order) {
            this.dateCountDown();
          }
          if (this.data.status == -1) {
            this.isExpire = true;
          } else if (this.data.status == -3) {
            let active_timestamp = new Date().getTime();
            let ended_at_timestamp = new Date(
              `${this.data.ended_at} 23:59:59`
            ).getTime();
            if (active_timestamp > ended_at_timestamp) {
              this.isExpire = true;
            }
          } else {
            this.isExpire = false;
          }
        });
    },
    // 获取体现信息
    getBalanceData() {
      this.$api
        .post("decoration/member/city/agent/balance", {
          type: this.identityType,
        })
        .then((res) => {
          this.balanceData = res;
        });
    },
    // 支付时间倒计时
    dateCountDown() {
      clearInterval(this.dateDown);
      this.dateDown = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown = this.countDown - 1;
        } else {
          clearInterval(this.dateDown);
        }
      }, 1000);
    },
    more() {
      this.$router.push({
        path: "/decoration/deputy/more",
      });
    },
    // 体现
    toEmbody() {
      this.$router.push({
        path: "/decoration/embody/embody",
        query: {
          type: 1,
          city_agent_id: this.data.id,
        },
      });
    },
    // 重新申请
    afreshSign() {
      this.$router.push({
        path: "/decoration/deputy/home",
        query: {
          type: this.data.type,
        },
      });
    },
  },
};
</script>
<style lang="less">
.details {
  min-height: 100%;
  background: #f5f6ff;
  h3 {
    margin: 0;
  }
  .detailsNav {
    background: #f5f6ff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      bottom: 10px;
    }
  }
  .content {
    .tip {
      display: flex;
      justify-content: space-between;
      padding: 10px 16px;
      background-color: #ffdbc6;
      align-items: center;
      color: #ff7e31;
      p {
        font-size: 14px;
        margin-right: 10px;
      }
      span {
        font-size: 12px;
        border-radius: 12px;
        border: 1px solid #ff7e31;
        height: 24px;
        line-height: 24px;
        min-width: 80px;
        text-align: center;
      }
    }
    .user {
      margin: 0 24px;
      display: flex;
      justify-content: space-between;
      background-image: url("./../../../assets/decoration/agent.png");
      background-repeat: no-repeat;
      background-size: 112px 88px;
      background-position: right bottom;
      div {
        h3 {
          font-size: 24px;
          font-weight: 700;
          color: #333333;
          margin-top: 16px;
          line-height: 33px;
        }
        p {
          font-size: 14px;
          color: #999999;
          display: flex;
          align-items: center;
          margin: 4px 0 16px;
          line-height: 20px;
          img {
            width: 40px;
            height: 16px;
            transform: translateY(-2px);
          }
        }
      }
    }
    .detailsData {
      .withdraw {
        margin: 0 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // border: 1px solid red;
        box-shadow: 0px 16px 48px 0px rgba(88, 83, 233, 0.5);
        height: 200px;
        border-radius: 16px;
        background-image: url("./../../../assets/decoration/earnings.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        p {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 17px;
          margin-top: 32px;
          padding: 0 16px;
        }
        .mid {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 45px;
          // margin: 12px 16px 0;
          padding: 0 16px;
          h1 {
            margin: 0;
            font-size: 32px;
            color: #ffffff;
          }
          span {
            background-color: rgba(116, 45, 45, 0.1);
            border-radius: 16px;
            padding: 4px 14px;
            line-height: 18px;
          }
          img {
            width: 20px;
            height: 20px;
            padding: 20px;
          }
          .forbidden {
            color: rgba(255, 255, 255, 0.5);
          }
          .noForbidden {
            color: rgba(255, 255, 255, 1);
          }
        }
        .btmDet {
          height: 70px;
          border-radius: 0 0 16px 16px;
          background-color: rgba(255, 255, 255, 0.2);
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            p {
              margin: 0;
              font-size: 12px;
              line-height: 17px;
              color: rgba(255, 255, 255, 0.7);
            }
            span {
              font-size: 14px;
              font-weight: 700;
              color: #ffffff;
              line-height: 20px;
              margin-top: 6px;
            }
          }
          .line {
            width: 1px;
            height: 30px;
            background: #6661f0;
          }
        }
      }
      .fy {
        margin-top: 24px;
      }
    }
  }
  .dialogStyle {
    padding: 20px;
    font-size: 14px;
    color: #6e727a;
    line-height: 20px;
  }
}
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #5853e9 !important;
}
</style>